<template>
  <div class="container">
    <DeviceHistoryDialog
      :visible.sync="deviceHistoryDialogVisible"
      :device-id="deviceId"
      isSubDevice
    />
    <el-form :model="form" inline ref="refForm" :rules="rules">
      <el-form-item class="small_label" :label="$t('common.address') + ':'" prop="address">
        <el-input
          v-model.trim="form.address"
          name="address"
          type="text"
          autocomplete="on"
          clearable
          size="small"
          style="width: 200px;"
          maxlength="255"
        />
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.componentName') + ':'" prop="deviceName">
        <el-input
          v-model.trim="form.deviceName"
          name="deviceName"
          type="text"
          autocomplete="on"
          clearable
          size="small"
          style="width: 200px;"
          maxlength="64"
        />
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.componentModel') + ':'" prop="deviceModel">
        <el-input
          v-model.trim="form.deviceModel"
          name="deviceModel"
          type="text"
          autocomplete="on"
          clearable
          size="small"
          style="width: 200px;"
          maxlength="64"
        />
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.componentNumber') + ':'" prop="deviceNumber">
        <el-input
          v-model.trim="form.deviceNumber"
          name="deviceNumber"
          type="text"
          autocomplete="on"
          clearable
          size="small"
          style="width: 200px;"
          maxlength="64"
        />
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.componentSerialNo') + ':'" prop="componentSerialNo">
        <el-input
          v-model.trim="form.deviceSerialNo"
          name="componentSerialNo"
          type="text"
          autocomplete="on"
          clearable
          size="small"
          maxlength="255"
        />
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.status') + ':'" prop="status">
        <el-select
          v-model="form.status"
          clearable
          filterable
          size="small"
          style="width: 150px;">
          <el-option
            v-for="item in defaultSubDeviceStatus"
            :key="item.value"
            :label="item.explain"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" @click="reset">{{$t('common.reset')}}</el-button>
        <el-button :loading="loading" type="primary" size="small" @click="queryDevice">
          {{$t('common.query')}}
        </el-button>
      </el-form-item>
    </el-form>
    <div class="control-container">
      <router-link to="/subDevice/create" style="margin-right: 10px">
        <el-button type="warning" size="small">
          {{$t('device.addNewComponent')}}
        </el-button>
      </router-link>
      <el-button :loading="exportLoading" @click="exportSubDeviceList" type="warning" size="small">
        {{$t('common.exportComponentList')}}
      </el-button>
    </div>
    <div class="target-container">
      <el-table
        ref="table"
        height="100%"
        border
        :data="displayData"
        :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
        :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
        header-cell-class-name="headerCellName">
        <el-table-column prop="addr" :label="$t('common.address')"/>
        <el-table-column prop="deviceName" :label="$t('common.componentName')"/>
        <el-table-column prop="deviceModel" :label="$t('common.componentModel')"/>
        <el-table-column prop="deviceNo" :label="$t('common.componentNumber')"/>
        <el-table-column prop="productionDate" :label="$t('common.productionDate')">
          <template slot-scope="scope">
            {{formatDate(scope.row.productionDate)}}
          </template>
        </el-table-column>
        <el-table-column prop="softwareVersion" :label="$t('common.softwareVersion')"/>
        <el-table-column prop="deviceSerialNo" :label="$t('common.componentSerialNo')"/>
        <el-table-column prop="status" :label="$t('common.status')">
          <template slot-scope="scope">
            {{subDeviceStatusVal(scope.row)}}
          </template>
        </el-table-column>
        <el-table-column prop="comment" :label="$t('common.comment')" show-overflow-tooltip/>
        <el-table-column :label="$t('common.associatedDevice')" width="100">
          <template slot-scope="scope" v-if="scope.row.deviceId">
            <router-link :to="{path: '/device/edit/' + scope.row.deviceId, query: {from: 'subDevice'}}">
              <el-button type="text" class="link" >
                {{$t('common.check')}}
              </el-button>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.label')" width="80">
          <template slot-scope="scope">
            <el-button
              type="text"
              class="link"
              @click="printSubDeviceLabel(scope.row)">
              {{$t('common.print')}}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.componentHistory')" width="100">
          <template slot-scope="scope">
            <el-button
              type="text"
              class="link"
              @click="checkSubDeviceHistory(scope.row.id)">
              {{$t('common.check')}}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.operate')" width="120">
          <template slot-scope="scope">
            <router-link :to="'/subDevice/edit/' + scope.row.id">
              <el-button type="text" class="link" >
                {{$t('common.revise')}}
              </el-button>
            </router-link>
            <el-button
              type="text"
              class="link"
              @click="deleteSubDevice(scope.row.id)">
              {{$t('common.delete')}}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      :total="totalCount"
      :pageSize="perpage"
      :current-page.sync="page"
      @current-change="onChangePage"
    />
  </div>
</template>

<script>
import {
  deviceDelete,
  devicesList,
} from '@/api/device';
import {
  Pagination,
} from '@/components';
import {
  defaultSubDeviceStatus,
} from '@/utils/defines';
import moment from "moment";
import {isValueEmpty, remove_ie_header_and_footer} from "@/utils";
import {initDeviceLabel} from '@/utils/deviceLabel';
import DeviceHistoryDialog from '../components/DeviceHistoryDialog';
import exportSubDeviceXlsx from "@/utils/exportSubDevice";

const defaultForm = {
  deviceCategory: [100, 100], // 后台无法处理数组长度1的情况
  address: undefined,
  deviceName: undefined,
  deviceModel: undefined,
  deviceNumber: undefined,
  status: undefined,
  deviceSerialNo: undefined,
};

export default {
  name: "SubDeviceManagement",
  components: {
    Pagination,
    DeviceHistoryDialog,
  },
  data() {
    return {
      form: Object.assign({}, defaultForm),
      searchParams: Object.assign({}, defaultForm),
      rules: {
      },
      page: 1,
      perpage: 20,
      totalCount: 0,
      listData: [],
      loading: false,
      defaultSubDeviceStatus,
      deviceHistoryDialogVisible: false,
      deviceId: undefined,
      exportLoading: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.devicesList();
    })
  },
  computed: {
    displayData() {
      return this.listData;
    },
  },
  methods: {
    onChangePage() {
      this.devicesList();
    },
    async devicesList() {
      const {
        deviceCategory,
        address,
        deviceName,
        deviceModel,
        deviceNumber,
        status,
        deviceSerialNo,
      } = this.searchParams;
      const {
        page,
        perpage,
      } = this;
      this.loading = true;
      try {
        const res = await devicesList({
          page,
          perpage,
          flag: deviceCategory,
          addr: address || undefined,
          deviceName: deviceName || undefined,
          deviceModel: deviceModel || undefined,
          deviceNo: deviceNumber || undefined,
          status: status || undefined,
          deviceSerialNo: deviceSerialNo || undefined,
        });
        const { data } = res;
        if (data.count !== undefined) {
          this.totalCount = data.count;
        }
        this.listData = data.records || [];
      } catch (e) {
        // do nothing.
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.page = 1;
      this.form = Object.assign({}, defaultForm);
      this.searchParams = Object.assign({}, defaultForm);
      this.devicesList();
    },
    queryDevice() {
      this.page = 1;
      this.searchParams = {...this.form};
      this.devicesList();
    },
    subDeviceStatusVal(row) {
      const {
        status,
      } = row;
      const subDeviceStatus = defaultSubDeviceStatus[String(status)];
      return subDeviceStatus ? subDeviceStatus.explain : status;
    },
    deleteSubDevice(id) {
      this.$confirm(this.$t('device.thisActionWillDeleteThisComponent'), this.$t('remindInfo.warning'), {
        confirmButtonText: this.$t('remindInfo.confirm'),
        cancelButtonText: this.$t('remindInfo.cancel'),
        type: 'warning',
      }).then(async () => {
        try {
          await deviceDelete({
            ids: [id],
          });
          this.$message({
            type: 'success',
            message: this.$t('common.deleteSuccess'),
          });
          this.devicesList();
        } catch (e) {
        }
      }).catch(() => {
        // do nothing.
      });
    },
    formatDate(date) {
      if (!date) {
        return '';
      }
      const updateDate = moment.utc(date);
      return updateDate.local().format('YYYY/MM/DD');
    },
    printSubDeviceLabel(row) {
      let iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      document.body.appendChild(iframe);
      iframe = initDeviceLabel({iframe, ...row, company: '网策科技', isSubDevice: true});
      setTimeout(() => {
        if (!!window.ActiveXObject || "ActiveXObject" in window) { //是否ie
          remove_ie_header_and_footer();
        }
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        document.body.removeChild(iframe);
        iframe = null;
      }, 200);
    },
    checkSubDeviceHistory(id) {
      this.deviceId = id;
      this.deviceHistoryDialogVisible = true;
    },
    async exportSubDeviceList() {
      this.exportLoading = true;
      try {
        const res = await devicesList({
          flag: [100, 100]
        });
        const { data } = res;
        const records = data.records || [];
        const subDeviceList = [];
        let supportProduct, formatData;
        for (let row of records) {
          supportProduct = row.supportProduct;
          formatData = {
            productionDate: this.formatDate(row.productionDate),
            statusVal: this.subDeviceStatusVal(row),
          };
          subDeviceList.push({
            ...row,
            rowspan: 1,
            ...formatData,
          });
        }
        exportSubDeviceXlsx({subDeviceList: subDeviceList});
      } catch (e) {
        // do nothing.
      } finally {
        this.exportLoading = false;
      }
    }
  }
}
</script>

<style scoped>
.container {
  height: 100%;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
}
.el-form {
  padding: 10px 20px 0;
  border-bottom: 1px solid #E5E5E5;
}
.el-form-item {
  margin-bottom: 10px;
}
.control-container {
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  margin: 10px 20px;
}
.target-container {
  flex: 1;
  display: -webkit-flex;
  display: flex;
  margin: 0 20px;
  height: 100%;
  overflow: auto;
}
.link {
  color: #169BD5;
  padding: 0 5px;
}
</style>
<style>
.headerCellName {
  background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
  background: -o-linear-gradient(#F9F9F9, #EEEEEE);
  background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
  background: linear-gradient(#F9F9F9, #EEEEEE);
}
.small_label .el-form-item__label {
  font-size: 12px;
}
</style>
